const categories = [
  {
    name: "Intersection Points",
    folder: "intersection-points",
    images: [
      {
        id: "lost-in-perspective",
        name: "Lost in Perspective",
        description:
          "A drawing depicting the blank look on a person’s face when they’re trying to find their way between the different intersecting perspectives of the surrounding world.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "fairy",
        name: "Fairy",
        description:
          "An androgynous being rests its wings while sitting on a suitcase. Where to?|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "0 40%",
      },
      {
        id: "a-sunday-kind-of-love",
        name: "A Sunday Kind of Love",
        description:
          "A drawing of two men in love enjoying an intimate moment.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "the-thinker",
        name: "The Thinker",
        description:
          "Portrait of a mature woman gathering her thoughts.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "free",
        name: "Free",
        description:
          "A portrait of Florence Welch, singer of the English rock band Florence and the Machine, inspired by their song “Free”.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: null,
        backgroundPosition: "0% 40%",
      },
      {
        id: "1958",
        name: "1958",
        description:
          "Portrait of a beautiful young woman.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "top center",
      },
      {
        id: "1957",
        name: "1957",
        description:
          "Portrait of a young man with a whole life ahead of him.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "0 25%",
      },
      {
        id: "her",
        name: "Her",
        description:
          "Portrait of a young woman indulging in the summer sunshine.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "top center",
      },
      {
        id: "leaving",
        name: "Leaving",
        description:
          "Somebody going somewhere. A moment in time.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "0 80%",
      },
      {
        id: "ninety-degrees",
        name: "Ninety Degrees",
        description:
          "What a change it can make when a man turns his head to the side.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "0 80%",
      },
      {
        id: "doting-mother",
        name: "Doting Mother",
        description:
          "Portrait of a young mother in the middle of parenting.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "manbun",
        name: "Manbun",
        description:
          "A young man with a lovely bun.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "top center",
      },
      {
        id: "respect-teachers",
        name: "Respect Teachers.",
        description:
          "A picture drawn in solidarity with the teachers' strike held nationwide at Hungarian schools on January 31st, 2022.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.|January, 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
      },
      {
        id: "furry-friends",
        name: "Furry friends",
        description:
          "A pair of young feline companions.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.|May, 2022",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "35% 0",
      },
      {
        id: "felis-catus",
        name: "Felis Catus",
        description:
          "A serious cat looking serious.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "heart-in-hand",
        name: "Heart in Hand",
        description:
          "There are different ways to read the lines on one’s palm.|Piece of my series Intersection Points in which I express what I see using a hatching/crosshatching technique where all shade comes from the main lines intersecting.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
    ],
  },
  {
    name: "Social and political illustrations",
    folder: "social-political",
    images: [
      {
        id: "american-sanctity-of-life-part-2",
        name: "American Sanctity of Life (Part 2)",
        description:
          "While the United States Supreme Court reverses the historic Roe v. Wade decision that has protected women’s right to have an abortion – all in the name of the sanctity of life –, it not only fails to ban AR-15 rifles in the wake of yet another tragic elementary school shooting, but legalizes carrying guns on the streets of New York – on the very same day.|Part 2 of 2.|Budapest, June 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
        backgroundPosition: "0 0",
      },
      {
        id: "american-sanctity-of-life-part-1",
        name: "American Sanctity of Life (Part 1)",
        description:
          "My reaction to Roe v. Wade being overturned by the Supreme Court of the United States, making the complete criminalization of abortions possible in many states, an event that has sent shock waves over the country – and the world.|Part 1 of 2.|Budapest, June 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
        backgroundPosition: "0 60%",
      },
      {
        id: "a-womans-rights",
        name: "A Woman’s Rights",
        description:
          "My reaction to anti-abortion laws all over the United States getting stricter and stricter and the possible overturn of the Supreme Court’s landmark decision Roe v. Wade looming over the country.|Budapest, June 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
        backgroundPosition: "0 15%",
      },
      {
        id: "a-leader-with-nothing-to-hide",
        name: "A Leader with Nothing to Hide",
        description:
          "My reaction to Hungarian prime minister Viktor Orbán repeatedly expressing how he feels about the refugee crisis, saying that one has to differentiate between “ good Christian” refugees and the ones fleeing Muslim countries.|Budapest, March 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
        backgroundPosition: "0 65%",
      },
      {
        id: "eyes-on-the-prize",
        name: "Eyes on the Prize",
        description:
          "My reaction to Russian president Vladimir Putin launching an attack on the sovereign nation of Ukraine, making people all around the world wonder what his long-term goals are.|Budapest, February 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
        backgroundPosition: "0 70%",
      },
      {
        id: "we-are-hungary",
        name: "We are Hungary",
        description:
          "Less than three weeks before the general elections and with a war raging next door, Hungary celebrates the anniversary of one of its many revolutions. Meanwhile its leaders continuously fail to help those oppressed and in need.|Budapest, March 15th, 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
      },
      {
        id: "hungary-hope-not-found",
        name: "Hungary: Hope Not Found",
        description:
          "After the far-right government wins another election by a landslide, Hungarian youth and different minorities start mourning their plans and dreams, with public interest in emigrating skyrocketing overnight.|Budapest, April 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
      },
      {
        id: "april-of-22",
        name: "April of ‘22",
        description:
          "For many Hungarians, the 2022 election means more than the previous ones. With the country’s mainstream politics going farther and farther to the right, another Orbán win could mean lots of people giving up on their homeland and starting over abroad.|Budapest, April 2022",
        thumbnail: "thumb.jpg",
        watermark: null,
        backgroundPosition: "0 75%",
      },
    ],
  },
  {
    name: "Color Drawings",
    folder: "color-drawings",
    images: [
      {
        id: "family-shapes",
        name: "Family Shapes",
        description: "Playtime between father and son.",
        thumbnail: "thumb.jpg",
        watermark: null,
      },
      {
        id: "dandelion-of-pride",
        name: "Dandelion of Pride",
        description:
          "A poster dedicated to Pride Month. This artwork is also available in a blue version.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "dandelion-of-pride-in-blue",
        name: "Dandelion of Pride (in Blue)",
        description:
          "A poster dedicated to Pride Month. This artwork is also available in a pink version.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "tata",
        name: "Tata",
        description:
          "My take on lovely summer evenings at the beautiful Tata castle, featuring the Old Lake in Tata, Hungary.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "winter-light",
        name: "Winter Light",
        description:
          "An old streetlamp joins some Christmas lights in illuminating a quiet night’s moment near the Christmas market at Óbuda’s Main Square in Budapest, Hungary.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "0 65%",
      },
      {
        id: "margaret",
        name: "Margaret",
        description:
          "A woman and her loyal companion take in the light Danube breeze on Budapest’s Margaret Bridge.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "top right",
      },
      {
        id: "him-and-her",
        name: "Him and Her",
        description: "Classic love in beautiful, historic Budapest.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "top right",
      },
      {
        id: "bloom",
        name: "Bloom",
        description:
          "My take on the spring vibes at Buda Castle’s famous Fisherman’s Bastion in Budapest, Hungary.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "new-hope",
        name: "New Hope",
        description: "A couple in love finds peace in each other’s arms.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
      {
        id: "mamarosa",
        name: "Mamarosa",
        description: "A rose drawn with love.",
        thumbnail: "thumb.jpg",
        watermark: null,
      },
      {
        id: "all-about-my-moms",
        name: "All About My Moms",
        description: "A happy family of three.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "15% 0",
      },
      {
        id: "doggo-dads",
        name: "Doggo Dads",
        description:
          "Some say that two men and a dog do not make a family. This artist disagrees. Features some landmarks from Siófok, Hungary.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
        backgroundPosition: "center left",
      },
      {
        id: "single",
        name: "Single",
        description:
          "A single mother holds her child’s hand. Features some landmarks from Tihany, Hungary.",
        thumbnail: "thumb.jpg",
        watermark: "watermark.jpg",
      },
    ],
  },
];

export default categories;
